import ILanguagePackage from "../ILanguagePackage";

const Belarusian: ILanguagePackage = {
    name: "Беларуская",
    header: "Кіраўніцтва Карыстальніка",
    content: [
        {
            heading: "Агульная інфармацыя",
            id: 'general-info',
            content: [
                {
                    type: 'text',
                    content:
                        "Гэтая сістэма з'яўляецца пашырэннем інструмента VIPER, створанага для дапамогі тэсціроўшчыкам, "+
                        "распрацоўшчыкам і іншым удзельнікам працэсу скраппинга ў вырашэнні штодзённых задач. Асноўная "+
                        "функцыя ValidationRuler - пошук унікальных фраз і атрыбутаў, уласцівых дакументам таго ці іншага "+
                        "тыпу для пэўнай катэгорыі тавараў. Акрамя таго, прыкладанне дае магчымасць параўноўваць дадзеныя "+
                        "табліцы excel з яе папярэднімі здымкамі (або параўноўваць два здымкі), што можа спатрэбіцца пры "+
                        "паўторным тэсціраванні. Гэты ж інструмент дазваляе праглядаць даныя табліцы Excel, калі яе нельга "+
                        "адкрыць у VIPER з-за празмернага памеру даных.",
                    links: [{title: "VIPER", href: "https://dataforspec.com/"}]
                },
                {
                    type: 'text',
                    content:
                        "Функцыянальнасць сістэмы будзе пашырацца па меры выяўлення новых задач. Поўны спіс бягучых "+
                        "магчымасцей можна пабачыць у [[lnk]], паказаным на малюнку 1. Доступ да яго можа атрымаць любы "+
                        "аўтарызаваны карыстальнік, націснуўшы назву «Validation Ruler» ў левым верхнім куце кожнага "+
                        "экрана. Больш падрабязна аб функцыянальнасці будзе апісана ў наступных раздзелах.",
                    links: [{title: "галоўным меню", href: "https://validationrulerapp.web.app/"}]
                },
                {
                    type: 'image',
                    content: {
                        imgId: 1,
                        src: '/manual/main_menu.png',
                        description: "Галоўнае меню і (выдзелена) асноўны шлях да яго."
                    }
                },
            ]
        },
        {
            heading: "Аўтарызацыя",
            id: 'authorization',
            content: [
                {
                    type: 'text',
                    content:
                        "Для доступу да функцыяналу сістэмы неабходна аўтарызавацца. Тут выкарыстоўваюцца ўліковыя даныя, "+
                        "прадастаўленыя [[lnk]]. Для зручнасці звычайна выкарыстоўваюцца дадзеныя для ўваходу ў [[lnk]], "+
                        "у гэтым выпадку маркер доступу dfs будзе згенераваны аўтаматычна. Карыстальнік застаецца аўтарызаваным, "+
                        "пакуль ён не выйдзе са свайго ўліковага запісу ўручную з дапамогай кнопкі ў правым верхнім куце "+
                        "кожнай старонкі або пакуль не дасягне перыяду бяздзейнасці ў 7 дзён.",
                    links: [
                        {title: "адміністратарам", href: "https://t.me/wanna_be_a_cat_bot"},
                        {title: "VIPER", href: "https://dataforspec.com/"},
                        {title: "VIPER", href: "https://dataforspec.com/"}
                    ]
                },
                {
                    type: 'text',
                    content:
                        "Калі карыстальнік папрасіў [[lnk]] зарэгістраваць яго з іншымі дадзенымі для ўваходу, адрознымі "+
                        "ад тых, што выкарыстоўваюцца ў [[lnk]], пры першым уваходзе сістэма таксама запатрабуе ўвесці "+
                        "токен доступу VIPER. Вы можаце знайсці яго ў загалоўку аўтарызацыі любога запыту [[lnk]], як "+
                        "паказана на малюнку 3. Для гэтага, знаходзячыся на любой з яго старонак і будучы аўтарызаваным, "+
                        "адкрыйце кансоль распрацоўніка (у большасці браўзераў - націснуўшы F12) , знайдзіце і адкрыйце "+
                        "ўкладку «Network», абнавіце старонку і ў спісе запытаў знайдзіце адзін з тыпаў дакументаў і націсніце "+
                        "на яго, як паказана на малюнку 2.",
                    links: [
                        {title: "адміністратара", href: "https://t.me/wanna_be_a_cat_bot"},
                        {title: "VIPER", href: "https://dataforspec.com/"},
                        {title: "VIPER", href: "https://dataforspec.com/"},
                    ]
                },
                {
                    type: 'image',
                    content: {
                        imgId: 2,
                        src: '/manual/dev_console_1.png',
                        description: "Укладка «Network» кансолі распрацоўшчыка і запыт дакумента."
                    }
                },
                {
                    type: 'text',
                    content:
                        "Пасля выбару неабходнага запыту неабходна адкрыць ўкладку Headers (звычайна адкрытая па "+
                        "змаўчанні), знайсці раздзел Request Headers, знайсці радок з загалоўкам Authorization і "+
                        "скапіяваць яго значэнне (без слова Basic!), як паказана на малюнку 3. Атрыманы токен неабходна "+
                        "ўвесці ў адпаведнае сістэмнае поле ValidationRuler.",
                },
                {
                    type: 'image',
                    content: {
                        imgId: 3,
                        src: '/manual/dfs_token.png',
                        description: "Пошук загалоўка аўтарызацыі і атрыманне токена VIPER."
                    }
                },
            ]
        },
        {
            heading: "Стварэнне акаўнта",
            id: 'sign-up',
            content: [
                {
                    type: 'text',
                    content:
                        "Калі карыстальнік мае ўліковы запіс у [[lnk]], але па-ранейшаму не мае доступу да сістэмы "+
                        "ValidationRuler, ён можа альбо звязацца з адным з адміністратараў, альбо самастойна "+
                        "зарэгістравацца з дапамогай токена VIPER, атрыманне якога падрабязна апісана ў [[lnk]]. Для "+
                        "гэтага на старонцы ўваходу націсніце на надпіс «or Sign Up Зарэгістравацца» пад кнопкай ўваходу, а "+
                        "затым увядзіце токен VIPER ва ўсплываючым акне. Затым карыстальнік альбо атрымае паведамленне "+
                        "пра памылку, альбо зможа ўвайсці са сваімі ўліковымі дадзенымі [[lnk]].",
                    links: [
                        {title: "VIPER", href: "https://dataforspec.com/"},
                        {title: "папярэднім раздзеле", href: "#authorization"},
                        {title: "VIPER", href: "https://dataforspec.com/"},
                    ]
                },
            ]
        },
        {
            heading: "Пошук па ключавых словах і фразах",
            id: 'rules-search',
            content: [
                {
                    type: 'text',
                    content:
                        "Старонка катэгорый падзелена на некалькі частак. Злева знаходзіцца спіс катэгорый карыстальнікаў, "+
                        "дзе вы можаце стварыць новую катэгорыю, а таксама выбраць прагляд дэталяў або выдаленне існуючай. "+
                        "Цэнтральнай часткай старонкі з'яўляецца рабочая вобласць, дзе адлюстроўваюцца дэталі катэгорыі "+
                        "і магчымыя дзеянні з ёй. Старонка базавай катэгорыі паказана на малюнку 4.",
                },
                {
                    type: 'image',
                    content: {
                        imgId: 4,
                        src: '/manual/cat_screen.png',
                        description: "Старонка катэгорый. Адна катэгорыя была створана, але не адкрыта."
                    }
                },
                {
                    type: 'text',
                    content:
                        "Пасля выбару катэгорыі са спісу яна з'яўляецца ў працоўнай вобласці. Уверсе знаходзіцца картка "+
                        "з асноўнай інфармацыяй:",
                },
                {
                    type: 'u-list',
                    content:
                        ["Нумар катэгорыі", "Вытворца", "Назва катэгорыі", "Дата стварэння", "Статус"],
                },
                {
                    type: 'text',
                    content:
                        "Ніжэй ёсць 5 кнопак:",
                },
                {
                    type: 'u-list',
                    content: [
                        "'Perform 1 step' - спрабуе выканаць неабходныя дзеянні для перамяшчэння катэгорыі ў наступны "+
                        "статус. Кожны такі крок можа заняць ад некалькіх секунд да 40 хвілін у залежнасці ад памеру "+
                        "катэгорыі і складанасці аперацыі.",

                        "'Perform all steps' - каб не сачыць за старонкай увесь гэты час, каб пачаць наступны этап "+
                        "апрацоўкі, прымушае катэгорыю прайсці ўсе этапы адначасова і дасягнуць альбо канчатковага "+
                        "стану (Attributes_Found), альбо памылкі, калі яна ўзнікае падчас апрацоўкі.",

                        "'Reload category' - дазваляе перазагрузіць табліцу з [[lnk]] і, пры жаданні, прайсці ўсе "+
                        "аперацыі яшчэ раз.",

                        "'View Excel' - перанакіроўвае вас на старонку [[lnk]] для гэтай катэгорыі",

                        "'View PVR' - перанакіроўвае вас на старонку [[lnk]] для гэтай катэгорыі."
                    ],
                    links: [
                        {title: "VIPER", href: "https://dataforspec.com/"},
                        {title: "прагляду Excel", href: "/user-guide#excel-diff"},
                        {title: "прагляду PVR", href: "/user-guide#pvr"},
                    ]
                },
                {
                    type: 'text',
                    content: "Кнопка 'Reload Category' недаступная, калі катэгорыя толькі што створана, а дзве іншыя - "+
                        "калі катэгорыя дасягнула канчатковага стану. Старонка падрабязных звестак аб катэгорыі паказана "+
                        "на малюнку 5.",
                },
                {
                    type: 'image',
                    content: {
                        imgId: 5,
                        src: '/manual/cat_details.png',
                        description: "Старонка падрабязных звестак аб катэгорыі."
                    }
                },
                {
                    type: 'text',
                    content:
                        "Пасля таго, як сістэма выканае ўсе неабходныя аперацыі па пошуку ключавых слоў і атрыбутаў, "+
                        "вынікі з'явяцца на старонцы. Карыстальнік зможа пераключацца паміж укладкамі дакумента і "+
                        "праглядаць ключавыя фразы або атрыбуты на свой выбар. Абодва будуць змяшчаць звесткі аб тым, у "+
                        "якіх дакументах яны знойдзены, а ў якіх не. Старонка з атрыманымі вынікамі паказана на малюнку 6.",
                },
                {
                    type: 'image',
                    content: {
                        imgId: 6,
                        src: '/manual/cat_results.png',
                        description: "Старонка з вынікамі пошуку фраз і атрыбутаў."
                    }
                },
                {
                    type: 'text',
                    content:
                        "Акрамя таго, унізе старонкі з'яўляецца поле, якое дазваляе карыстальніку правесці аналіз пэўнай "+
                        "фразы і праверыць, у якіх дакументах яна сустракаецца. Пасля атрымання вынікаў такога аналізу "+
                        "карыстальнік можа пераключацца паміж укладкамі дакументаў, каб пераканацца ў унікальнасці фразы "+
                        "для пэўнага тыпу. Вынік такога пошуку паказаны на малюнку 7.",
                },
                {
                    type: 'image',
                    content: {
                        imgId: 7,
                        src: '/manual/custom_phrase_test.png',
                        description: "Старонка вынікаў аналізу фраз."
                    }
                },
                {
                    type: 'text',
                    content:
                        "У цяперашні час гэта ўсе даступныя функцыі з гэтай вобласці. У далейшым ён будзе ўдасканальвацца "+
                        "і пашырацца, як толькі з'явяцца новыя патрабаванні або ідэі.",
                },
            ]
        },
        {
            heading: "Параўнанне здымкаў табліцы",
            id: 'excel-diff',
            content: [
                {
                    type: 'text',
                    content:
                        "Пры скрэпінгу не варта забываць аб адной асаблівасці гэтай галіны: дадзеныя часта мяняюцца. І "+
                        "гэта можа быць цяжка, ці нават нерэальна, візуальна кантраляваць такія змены. На шчасце, [[lnk]] "+
                        "забяспечвае інструменты для параўнання з дадзенымі ў базе дадзеных. Але што, калі неабходна "+
                        "правесці параўнанне з больш ранняй версіяй даных, якая яшчэ не выпушчана?",
                    links: [{title: "VIPER", href: "https://dataforspec.com/"}]
                },
                {
                    type: 'text',
                    content:
                        "Менавіта для такіх мэтаў ValidationRuler забяспечвае функцыянальнасць параўнання даных двух "+
                        "здымкаў табліц. Для гэтага патрабуецца толькі ўвесці нумар іх катэгорыі і час стварэння "+
                        "(параметр dt спасылкі на здымкі). Калі неабходна параўнаць дадзеныя бягучай табліцы - першае з "+
                        "dt можна пакінуць пустым.",
                },
                {
                    type: 'text',
                    content:
                        "Каб знайсці здымак дадзеных за пэўную дату, націсніце кнопку 'HISTORY' ў правым верхнім куце "+
                        "экрана на старонцы катэгорыі ў [[lnk]] (малюнак 8). У атрыманай табліцы абярыце радок з тэкстам "+
                        "'New Excel file loaded' для патрэбнай даты і націсніце кнопку 'View Excel' побач з ім (малюнак 9). "+
                        "На атрыманай старонцы ў радку url можна знайсці параметр dt, які нам і патрэбны (малюнак 10).",
                    links: [{title: "VIPER", href: "https://dataforspec.com/"}]
                },
                {
                    type: 'image',
                    content: {
                        imgId: 8,
                        src: '/manual/history_location.png',
                        description: "Размяшчэнне кнопкі 'HISTORY'."
                    }
                },
                {
                    type: 'image',
                    content: {
                        imgId: 9,
                        src: '/manual/snapshot_location.png',
                        description: "Пошук неабходнага здымка дадзеных."
                    }
                },
                {
                    type: 'image',
                    content: {
                        imgId: 10,
                        src: '/manual/dt_location.png',
                        description: "Размяшчэнне параметра dt."
                    }
                },
                {
                    type: 'text',
                    content:
                        "Пасля ўводу неабходных параметраў і націску кнопкі 'Compare' пачнецца працэс загрузкі і "+
                        "параўнання табліц, які можа заняць да 5 хвілін. У канцы апрацоўкі карыстальнік атрымае табліцу "+
                        "змяненняў, як паказана на малюнку 11. У ёй колер слупка (чырвоны або зялёны) азначае, што такі "+
                        "атрыбут быў раней, а цяпер ён знік, ці наадварот, проста з'явілася. У сваю чаргу, лініі таксама "+
                        "могуць мець розны колер у залежнасці ад іх стану. Нязменны будзе мець колер фону. Новыя стануць "+
                        "зялёнымі, зніклыя - чырвонымі, а часткова змененыя ў неістотных слупках - сінімі. Слупкі дакументаў, "+
                        "выявы і спасылкі лічацца неістотнымі, як і любыя іншыя, калі яны пазначаны як новыя або адсутныя. "+
                        "Больш за тое, калі можна вызначыць, па значэнні якой ячэйкі радок набыла пэўны статус - такая "+
                        "ячэйка будзе выдзелена крыху больш яркім колерам. Выключэнне складаюць змененыя (сінія) радкі, "+
                        "у якіх адзін з атрыбутаў з'явіўся або знік з-за дадання або знікнення цэлага слупка. Для іх "+
                        "значэнні ў гэтых слупках (ужо афарбаваных) не будуць дадаткова вылучацца больш яркім колерам.",
                },
                {
                    type: 'image',
                    content: {
                        imgId: 11,
                        src: '/manual/cmp_result.png',
                        description: "Вынік параўнання бягучай табліцы катэгорыі 432 са старым здымкам."
                    }
                },
                {
                    type: 'text',
                    content:
                        "Вы таксама можаце звярнуцца да здымка па яго індэксе, не выкарыстоўваючы пазнаку часу з гісторыі. "+
                        "У гэтым выпадку выкарыстоўваецца адмоўны індэкс. Як ужо згадвалася, для апошняга здымка вы "+
                        "можаце пакінуць поле пустым, для перадапошняга вы можаце выкарыстоўваць індэкс -1, для "+
                        "перад-перадапошняга - індэкс -2 і гэтак далей.",
                    links: []
                },
                {
                    type: 'text',
                    content:
                        "У правым верхнім куце старонкі ёсць 4 галачкі рознага колеру. Выбіраючы або здымаючы іх выбар, "+
                        "вы можаце выбраць радкі, статус якіх вы хочаце бачыць. Напрыклад, калі вам патрэбныя толькі "+
                        "выдаленыя радкі - вы можаце зняць усе сцяжкі, акрамя чырвонага.",
                    links: []
                },
                {
                    type: 'text',
                    content:
                        "Акрамя таго, гэты інструмент дазваляе проста праглядаць бягучую табліцу (або любы здымак). Для гэтага трэба пакінуць абодва палі пустымі (або запоўніць іх аднолькавымі значэннямі dt). Гэта можа быць карысна ў тых выпадках, калі табліцу нельга адкрыць у [[lnk]] з-за яе вялікага памеру. ValidationRuler лепш аптымізаваная, таму дазваляе без праблем адкрываць табліцы нават з 60 000 радкоў, а можа і больш, пакуль проста не было магчымасці праверыць гэта.",
                    links: [{title: "VIPER", href: "https://dataforspec.com/"}]
                },
            ]
        },
        {
            heading: "Прагляд PVR",
            id: 'pvr',
            content: [
                {
                    type: 'text',
                    content:
                        "Яшчэ адна праблема, з якой могуць сутыкнуцца карыстальнікі [[lnk]], гэта праблемы з загрузкай PVR з-за недахопу аператыўнай памяці. Менавіта для такіх выпадкаў ValidationRuler дае магчымасць праглядаць гэты справаздачу ў больш аптымізаваным выглядзе. Каб зрабіць гэта, абярыце опцыю [[lnk]] у галоўным меню, увядзіце нумар катэгорыі ў поле і націсніце кнопку 'Load PVR'. Пасля загрузкі дадзеных карыстальнік зможа выбраць тып файлаў, для якіх ён хоча праглядзець выяўленыя праблемы. Табліца будзе адлюстроўваць той жа змест, што і зыходная старонка [[lnk]], як паказана на малюнку 12.",
                    links: [
                        {title: "VIPER", href: "https://dataforspec.com/"},
                        {title: "'PVR Documents'", href: "/pvr"},
                        {title: "VIPER", href: "https://dataforspec.com/"},
                    ]
                },
                {
                    type: 'image',
                    content: {
                        imgId: 12,
                        src: '/manual/cat_pvr.png',
                        description: "Прагляд старонкі з PVR для катэгорыі 239."
                    }
                },
                {
                    type: 'text',
                    content:
                        "Варта адзначыць, што на гэтай старонцы будуць адлюстроўвацца толькі праблемы з файламі розных тыпаў. Адсутныя значэнні іншых слупкоў можна адсачыць, адфільтраваўшы значэнні па 'MISSING' ў праглядзе табліцы Excel.",
                },
            ]
        },
        {
            heading: "Праверка скрыжавання катэгорый",
            id: 'healthcheck',
            content: [
                {
                    type: 'text',
                    content:
                        "Дакументацыя для гэтага функцыяналу на беларускай мове яшчэ не створана. Яна даступная толькі "+
                        "ў англійскай версіі. Прыносім прабачэнні за часовыя нязручнасці.",
                    links: []
                },
                // {
                //     type: 'text',
                //     content:
                //         "Sometimes filters on manufacturers' websites work in such a way that the same products fall "+
                //         "into several categories at once. Such duplication would be critical for [[lnk]] system. However, "+
                //         "this problem is practically impossible to catch manually. That is why the functionality "+
                //         "for searching for category intersections was developed.",
                //     links: [
                //         {title: "SpecID", href: "https://project.spec-id.com/products/advancedSearch"},
                //     ]
                // },
                // {
                //     type: 'text',
                //     content:
                //         "The flow is pretty easy and straightforward. You just need to select the manufacturer from the "+
                //         "list, as shown on the Figure 13, and press the 'Analyze' button. The system will try to load the "+
                //         "previous check result if such exists or generate a new report. This can take a very long time, up "+
                //         "to an hour, depending on the number of categories and their sizes. The system checks if there are "+
                //         "some rows with the same URL, name, Size and (optionally) Shape common for different categories. "+
                //         "A row with not specified Shape is considered a duplicate of rows with Shape if the other "+
                //         "attributes match. Sometimes in the intersection report you may see several rows that look the "+
                //         "same. But they actually have different URLs, and that's why each of them is included into the "+
                //         "table. The result of such checks is shown on the Figure 14.",
                //     links: []
                // },
                // {
                //     type: 'image',
                //     content: {
                //         imgId: 13,
                //         src: '/manual/intersections_manufacturer_selection.png',
                //         description: "The list of available manufacturers."
                //     }
                // },
                // {
                //     type: 'image',
                //     content: {
                //         imgId: 14,
                //         src: '/manual/intersections_result.png',
                //         description: "Intersections report for Gerflor manufacturers. A lot of intersections found, some of them look the same but have different URLs."
                //     }
                // },
                // {
                //     type: 'text',
                //     content:
                //         "You can always re-analyze the manufacturer and load the fresh report by pressing the "+
                //         "'Rerun analysis' button. The second button ('Show cat sizes') allows us to check the number of "+
                //         "categories and their sizes. It may be useful for product managers.",
                // },
            ]
        },
        {
            heading: "Кіраванне карыстальнікамі (для адміністратараў)",
            id: 'users-management',
            content: [
                {
                    type: 'text',
                    content:
                        "Дакументацыя для гэтага функцыяналу на беларускай мове яшчэ не створана. Яна даступная толькі "+
                        "ў англійскай версіі. Прыносім прабачэнні за часовыя нязручнасці.",
                },
                // {
                //     type: 'text',
                //     content:
                //         "If you are an admin, there is a 'Manage Users' tab in the main menu. It's page contains a left "+
                //         "sidebar with a list of all users and a main area with selected user's details and available actions. "+
                //         "Initially, this page was also planned to allow viewing of the user's recent actions, but this "+
                //         "functionality was later rejected as unnecessary. The user management page is shown in Figure 15.",
                // },
                // {
                //     type: 'image',
                //     content: {
                //         imgId: 15,
                //         src: '/manual/user_management.png',
                //         description: "User management page."
                //     }
                // },
                // {
                //     type: 'text',
                //     content:
                //         "Here you can create new user account by clicking the button in the lower left corner of the "+
                //         "page and entering the credentials (it is recommended to use [[lnk]]'s credentials for better "+
                //         "integration). You can also remove users if they are lower than you in access rights, promote "+
                //         "regular users to administrators, and superadmins can also demote administrators back to regular "+
                //         "users or create new superadmins.",
                //     links: [
                //         {title: "VIPER", href: "https://dataforspec.com/"},
                //     ]
                // },
            ]
        },
        {
            heading: "Запіс памылак",
            id: 'logs',
            content: [
                {
                    type: 'text',
                    content:
                        "Кожная сістэма час ад часу мае розныя праблемы. І важна ўмець гэта адсочваць. Таму ў галоўным "+
                        "меню ёсць спецыяльная старонка для прагляду журналаў. На ім у верхняй частцы экрана знаходзіцца "+
                        "панэль для выбару ўзроўню лага, а таксама форма для выбару максімальнай колькасці радкоў якія "+
                        "адлюстроўваюцца. Па змаўчанні даныя бяруцца з самых апошніх файлаў, але спецыяльны сцяжок "+
                        "дазваляе ўключаць і больш старыя даныя, калі ў гэтым ёсць неабходнасць. Малюнак 16 паказвае "+
                        "старонку агляду часопіса ўзроўню INFO.",
                },
                {
                    type: 'image',
                    content: {
                        imgId: 16,
                        src: '/manual/logs.png',
                        description: "Старонка прагляду часопіса."
                    }
                },
            ]
        },
        {
            heading: "Дадатковая інфармацыя",
            id: 'additional',
            content: [
                {
                    type: 'text',
                    content:
                        "Наступныя крокі ў распрацоўцы ValidationRuler:",
                },
                {
                    type: 'o-list',
                    content: [
                        "Даданне новага тыпу кнопак у дадатак да ўжо існуючых важных дзеянняў і дэструктыўных дзеянняў - "+
                        "інфармацыйных кнопак, хутчэй за ўсё, сіняга або шэрага колеру, каб лагічна падзяляць розныя "+
                        "тыпы дзеянняў;",

                        "Перанос панэлі кіравання карыстальнікам на асобную старонку, даданне функцыі прагляду катэгорый "+
                        "карыстальнікаў і кіравання імі (выдаленне);",

                        "Даданне значкоў да кнопак, якія могуць замяняць тэкст на невялікіх памерах экрана;",

                        "Змена дызайну на адаптыўны, каб карыстальнікам было зручна працаваць з любой прылады.",
                    ],
                },
                {
                    type: 'text',
                    content:
                        "На дадзены момант гэта ўся важная інфармацыя аб сістэме. Дадатковую інфармацыю можна знайсці [[lnk]].",
                    links: [{title: "тут", href: "https://www.youtube.com/watch?v=dQw4w9WgXcQ"}]
                },
            ]
        },
    ],
    additional: {
        tableOfContents: "Змест",
        picture: "Малюнак"
    },
}

export default Belarusian;